<template>
    <div>
        <slot :category="category" />
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{
        categoryId: string;
        _type?: string;
        _key?: string;
        title?: string;
        componentId?: string;
    }>();

    const { search } = useCategorySearch();

    // useAsyncData shares the SSR fetch result with the client via the Nuxt
    // payload. Without this the client refetches the category during hydration,
    // and while that request is in flight `category` is undefined — which is
    // exactly when the H1 in the listing layout falls back to an empty value
    // and crawlers (Screaming Frog rendered crawl) capture a missing H1.
    type CategoryResponse = Awaited<ReturnType<typeof search>>;
    const { data: categoryResponse } = await useAsyncData<CategoryResponse>(
        `plp-category:${props.categoryId}`,
        () => search(props.categoryId),
    );

    const { category } = useCategory(categoryResponse as Ref<CategoryResponse>);

    // Note: SEO data is now handled at the page level in the useResolvePage composable
    // This keeps our component code cleaner and focused on just providing the category data
</script>
